import * as React from "react";
import PrayerCalendar from "../prayerSetting/PrayerCalendar";
import { usePrinterExtraStore } from "../../state/storePrinterExtra";
import LeftPrinter from "./LeftPrinter";
import RightPrinter from "./RightPrinter";

const PrinterCalendar = () => {
  const { printer_logo_url, printer_logo } = usePrinterExtraStore(
    (state) => state
  );

  return (
    <div className=" w-fit h-full m-auto p-auto flex items-start ">
      <div className="w-[210mm] min-h-[297mm] p-[5mm] rounded-[1px] bg-white shadow-sm ">
        <div className=" w-full gap-5 columns-3">
          <LeftPrinter />
          <div className="px-12">
            <img
              className="text-center items-center align-middle "
              width="150"
              height="100"
              src={printer_logo || printer_logo_url}
              alt="logo"
            />
          </div>
          <RightPrinter />
        </div>
        <PrayerCalendar show={false} />
      </div>
    </div>
  );
};

export default PrinterCalendar;
